// extracted by mini-css-extract-plugin
export default {"infoButton":"SaveNewCardCheckbox-module__infoButton___rjGi8","infoImage":"SaveNewCardCheckbox-module__infoImage___3wBOQ"};